import React from "react";
import { Layout } from "../../layouts/Layout";
import { AboutEleven } from "../../components/About/AboutEleven";
import { TeamAreaOne } from "../../components/TeamAreas/TeamAreaOne";
import { AboutValuesSection } from "../../components/About/AboutValuesSection";
import { BrandSix } from "../../components/Brand/BrandSix";
import { CtaAreaFive } from "../../components/CtaAreas/CtaAreaFive";

const AboutPageFive = () => {
  return (
    <Layout
      breadcrumb={"About Us"}
      title={"About Zawix Business Consultants"}
      seo={{
        description:
          "Learn about Zawix Business Consultants, trusted advisors in Pakistan since 2015 for company registration, tax, audit, and regulatory compliance support.",
      }}
    >
      {/* about-area */}
      <AboutEleven />

      {/* about-area */}
      {/* <AboutTwelve /> */}

      {/* values */}
      <AboutValuesSection />

      {/* cta-area */}
      <CtaAreaFive />

      {/* team-area */}
      <TeamAreaOne />

      {/* clients */}
      <BrandSix />

     
    </Layout>
  );
};

export default AboutPageFive;
